import BannerImgText from '@/components/BannerImgText';
import Card from '@/components/Card';
import EmptyResult from '@/components/EmptyResult';
import FileUpload from '@/components/FileUpload';
import Modal from '@/components/Modal';
import { useRemoveImageBackground } from '@/hooks/ai.hooks';
import { useCallback, useState } from 'react';
import { downloadBase64Image } from '@/utils/file.utils';

const RemoveBackgroundPage = () => {
  const [file, setFile] = useState<File>();
  const { mutate, isPending, data } = useRemoveImageBackground();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: any = data; // I need to create the type for it.

  const onRemoveBackground = useCallback(() => {
    mutate(file);
  }, [file]);

  const HandleDownloadFile = useCallback(() => {
    if (file && result?.data) {
      downloadBase64Image(result.data.image, file.name);
    }
  }, [file, result]);

  return (
    <div className="container">
      <BannerImgText
        title="Détourage d'une voiture"
        img="media/ia-images/remove-background.webp"
      />
      <div className="grid grid-cols-2 gap-3">
        <Card title="Séléction des fichiers">
          <div className="mb-5">
            <FileUpload setFileUpload={setFile} />
          </div>
          <div className="text-center">
            <button
              className="btn btn-fill btn-primary justify-center w-auto min-w-20"
              onClick={onRemoveBackground}
              disabled={!file}
            >
              {isPending ? '...En Cours' : 'GO'}
            </button>
          </div>
        </Card>
        <Card title="Résultat du détourage">
          <div className={(result  || isPending) ? 'hidden' : ''}>
            <EmptyResult text="Aucune analyse trouvé" />
          </div>
          {isPending && 
            <img  className="m-auto" src="./loading.svg"  />
          }
          {!isPending && data && (
            <div className={data ? '' : 'hidden'}>
              <div className="grid grid-cols-3 mb-3">
                <p>Nom du fichier</p>
                <p>{result.data.filename}</p>
              </div>
              <button
                className="btn btn-sm btn-info w-fit mr-1"
                data-modal-toggle="#modal-file-view"
              >
                <i className="ki-outline ki-eye"></i>
                Aperçu
              </button>
              <button
                className="btn btn-sm btn-primary"
                onClick={HandleDownloadFile}
              >
                <i className="ki-filled ki-cloud-download"></i>
                Télécharger le fichier
              </button>
            </div>
          )}
        </Card>
      </div>
      <Modal
        id="modal-file-view"
        title="Aperçu"
        showSecondBtn
        secondBtnLabel="Télécharger"
        size="large"
        onClickSecondBtn={HandleDownloadFile}
      >
        {!isPending && data && (
          <img
            className="m-auto"
            src={`data:image/jpeg;base64,${result.data.image}`}
          />
        )}
      </Modal>
    </div>
  );
};

export default RemoveBackgroundPage;
